__turbopack_context__.v({
  "search_pagination_list": "PweBFq_search_pagination_list",
});
